import { commonTranslations } from './common';
import { homeTranslations } from './home';
import { servicesTranslations } from './services';
import { contactTranslations } from './contact';
import { aboutTranslations } from './about';
import { documentsTranslations } from './documents';
import { projectsTranslations } from './projects';
import { blogTranslations } from './blog';

// Combine all translations
export const translations = {
  en: {
    ...commonTranslations.en,
    ...homeTranslations.en,
    ...servicesTranslations.en,
    ...contactTranslations.en,
    ...aboutTranslations.en,
    ...documentsTranslations.en,
    ...projectsTranslations.en,
    ...blogTranslations.en,
  },
  ar: {
    ...commonTranslations.ar,
    ...homeTranslations.ar,
    ...servicesTranslations.ar,
    ...contactTranslations.ar,
    ...aboutTranslations.ar,
    ...documentsTranslations.ar,
    ...projectsTranslations.ar,
    ...blogTranslations.ar,
  }
};

// Export individual modules for specific use cases
export { commonTranslations } from './common';
export { homeTranslations } from './home';
export { servicesTranslations } from './services';
export { contactTranslations } from './contact';
export { aboutTranslations } from './about';
export { documentsTranslations } from './documents';
export { projectsTranslations } from './projects';
export { blogTranslations } from './blog';

// Export types
export type Language = 'en' | 'ar';
export type TranslationKey = keyof typeof translations.en;
